<span class="productMapper vetcorPrice">
   <section
      class="p-2"
      *ngIf="state$ | async as state">
      <div class="adminPriceDashboard">
         <div class="statsCodesContainer">
            <div class="statsContainerLeft">
               <div class="pageHeader-row mb-3">
                  <div class="pageHeader-text">
                     <div class="heading">Admin Pricing Dashboard</div>
                  </div>
                  <div class="pageHeader-buttons">
                     <button
                        class="v-button v-button-md wider-button v-green mr-2"
                        (click)="showUploadPricingCsvModal()">
                        <i class="fa-solid fa-computer"></i>
                        &nbsp;&nbsp;Manage Pricing Imports
                     </button>
                     <button class="v-button v-button-md wider-button v-green disabled">
                        <i class="fa-solid fa-dollar"></i>
                        &nbsp;&nbsp;View Pricing Rules
                     </button>
                     <div class="header-spacer">|</div>
                     <div class="header-user">
                        {{ currentAdmin }}
                        <br />
                        <span class="user-position">{{ currentPosition }}</span>
                     </div>
                     <img src="/assets/welcomeUser.png" />
                  </div>
               </div>

               <div class="pageHeader-row mb-3 mt-1">
                  <div class="pageHeader-text">
                     <vc-single-select-dropdown
                        label="Select Cycle"
                        [filter]="false"
                        [optionLabel]="'label'"
                        [optionValue]="'value'"
                        [items]="displayTagOptions()"
						sizeClass="v-dropdown-sm"
                        placeholder="Select Cycle"
                        (selectionChange)="displayTagFilter.set($event)"></vc-single-select-dropdown>
                  </div>
               </div>

               @if (allPractices()?.length > 0) {
               <!-- Stats Section -->
               <div
                  *ngIf="!!dashboardStats"
                  class="stats-container">
                  <div class="stat-box">
                     <div class="icon-wrapper-wrapper">
                        <div class="icon-wrapper">
                           <i class="icon fas fa-tasks"></i>
                        </div>
                     </div>
                     <h3>Codes Requested for Review</h3>
                     <p>
                        {{ (dashboardStats.reviewRequested == 0 ? codesRequestedReview : dashboardStats.reviewRequested) | number }}
                        <span
                           *ngIf="isLoadingAllPractices"
                           style="font-size: 14px">
                           LOADING...
                        </span>
                     </p>
                  </div>
                  <div class="stat-box">
                     <div class="icon-wrapper-wrapper">
                        <div class="icon-wrapper">
                           <i class="icon fas fa-business-time"></i>
                        </div>
                     </div>
                     <h3>Codes Pending Writeback</h3>
                     <p>
                        {{ (dashboardStats.pendingWriteback == 0 ? codesPendingWriteback : dashboardStats.pendingWriteback) | number }}
                        <span
                           *ngIf="isLoadingAllPractices"
                           style="font-size: 14px">
                           LOADING...
                        </span>
                     </p>
                  </div>
                  <div
                     class="stat-box"
                     style="padding-top: 20px">
                     <div class="icon-wrapper-wrapper">
                        <div class="icon-wrapper">
                           <i class="icon fas fa-calendar-check"></i>
                        </div>
                     </div>
                     <p style="margin-top: -5px; margin-bottom: -5px">
                        {{ !isLoadingAllPractices ? (practiceCompletion || 0) : 0 }}%
                        <span
                           *ngIf="isLoadingAllPractices"
                           style="font-size: 14px">
                           LOADING...
                        </span>
                     </p>
                     <h3>Practice Completion</h3>
                     <p style="font-size: 13px; font-weight: 500; text-align: right; margin-bottom: 3px">{{ allPractices()?.length }} practices</p>
                     <div
                        class="progress mb-3"
                        style="margin-bottom: 0px !important"
                        role="progressbar"
                        aria-valuenow="60"
                        aria-valuemin="0"
                        aria-valuemax="100">
                        <div
                           class="progress-bar bg-info"
                           [ngStyle]="{ width: (practiceCompletion || 0) + '%' }" >
                           {{ !isLoadingAllPractices ? (practiceCompletion || 0) : 0 }}%
                        </div>
                     </div>
                  </div>
                  <div
                     class="stat-box"
                     style="padding-bottom: 0px; padding-right: 15px">
                     <h3>Writeback Success</h3>

                     <div
                        style="
                           margin-top: 0px;
                           margin-bottom: 0px;
                           margin-right: 10px;
                           font-size: 20px;
                           width: fit-content;
                           float: left;
                           font-weight: 700;
                           margin-left: 5px;
                           text-align: left;
                           line-height: 25px;
                        "
                        class="writebackSuccessText">
						   <span *ngIf="statusProgress >= 1">
                              You have {{ statusProgress / 100 | percent : "1.0-2" }}
                              <br />
                              writeback success
                              <!--<div style="margin-top:-5px; text-align:left"><span style="color:#d41a30; font-size:13px; font-weight:600"><i class="fa fa-undo"></i> &nbsp;Retry Failed Writebacks</span></div>-->
						   </span>
						   <span *ngIf="!statusProgress || statusProgress < 1">
                              Writeback has not started
						   </span>
                     </div>

                     <div
                        class="circular-progress"
                        *ngIf="!isLoadingAllPractices">
                        <svg
                           class="progress-circle"
                           viewBox="0 0 36 36"
                           style="transform: scale(0.8); transform-origin: center">
                           <!-- Background Circle -->
                           <path
                              class="circle-bg"
                              d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0-31.831"></path>
                           <!-- Progress Circle -->
                           <path
                              class="circle"
                              [ngStyle]="{ stroke: statusColor }"
                              [attr.stroke-dasharray]="strokeDashArray"
                              d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0-31.831"></path>
                        </svg>
                        <div class="progress-text">
                           <span class="percentage">{{ statusProgress / 100 | percent : "1.0-2" }}</span>
                        </div>
                        <div style="margin-top: -5px">
                           <span
                              class="status"
                              [ngStyle]="{ color: statusColor }">
                              {{ statusLabel }}
                           </span>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Practices Scheduled for Review and Writeback -->
               <div
                  class="row"
                  style="justify-content: space-between; margin-left: auto; margin-right: auto">
                  <div class="section half-width">
                     <div class="section-header">
                        <h3>Upcoming Practices Scheduled for Review</h3>
                        <i
                           style="color: #d0d0d0"
                           class="icon fas fa-tasks"></i>
                     </div>
                     <div *ngIf="isLoadingAllPractices; else reviewList">
                        <div class="spinner"></div>
                        <!-- Spinner for loading -->
                     </div>
                     <ng-template #reviewList>
                        <div style="height: 365px; overflow-y: scroll">
                           <div
                              *ngFor="let practice of upcomingPractices"
                              class="practice-item">
                              <div class="practice-left">
                                 <a
                                    routerLink="{{ practice.practiceSKey }}"
                                    style="text-decoration: none">
                                    <p class="practice-name">{{ practice.practiceName }}</p>
                                 </a>
                                 <p class="practice-manager">Hospital Manager: {{ practice.hmFirstName }} {{ practice.hmLastName }}</p>
                                 <p class="practice-email">
                                    <a href="mailto:{{ practice.hmEmail }}">{{ practice.hmEmail }}</a>
                                 </p>
                              </div>
                              <div class="practice-right">
                                 <p class="practice-date">{{ practice.discussionComplete | date : "MM/dd/yyyy" }}</p>
                              </div>
                           </div>
                        </div>
                     </ng-template>
                  </div>

                  <div class="section half-width">
                     <div class="section-header">
                        <h3>Practices Needing to Submit Codes</h3>
                        <i
                           style="color: #d0d0d0"
                           class="icon fas fa-business-time"></i>
                     </div>
                     <div *ngIf="isLoadingAllPractices; else completedList">
                        <div class="spinner"></div>
                        <!-- Spinner for loading -->
                     </div>
                     <ng-template #completedList>
                        <div style="height: 365px; overflow-y: scroll">
                           <div
                              class="practice-item"
                              style="flex-wrap: wrap; justify-content: space-between; gap: 5px">
                              <ng-container *ngFor="let practice of unsubmittedPractices">
                                 <div
                                    class="practice-left"
                                    style="flex: 1 1 47%; max-width: 47%">
                                    <a
                                       routerLink="{{ practice.practiceSKey }}"
                                       style="text-decoration: none">
                                       <p
                                          class="practice-name"
                                          style="color: #ed5a68; margin-bottom: 3px">
                                          {{ practice.practiceName }}
                                       </p>
                                    </a>
                                    <p class="practice-manager">Hospital Manager: {{ practice.hmFirstName }} {{ practice.hmLastName }}</p>
                                    <p class="practice-email">
                                       <a href="mailto:{{ practice.hmEmail }}">{{ practice.hmEmail }}</a>
                                    </p>
                                 </div>
                              </ng-container>
                           </div>
                        </div>
                     </ng-template>
                  </div>
               </div>
               }
            </div>
         </div>

         <!-- All Practices Table -->
         <div
            class="section"
            *ngIf="allPractices()?.length > 0">
            <div
               class="section-header"
               style="border-bottom: 0px; padding: 0px 3px">
               <h3>All Practices</h3>
               &nbsp;

               <div
                  class="flex-column ml-2 prodCodeFilterCon prodHospitalFilterCon"
                  style="margin-left: 20px !important; margin-bottom: 0px !important">
                  <input
                     class="w-100 prodCodeFilter"
                     type="text"
                     [(ngModel)]="practiceSearchTerm"
                     placeholder="Search..."
                     style="
                        min-width: 275px !important;
                        max-width: 275px !important;
                        border-radius: 3px;
                        padding-left: 46px !important;
                        height: 37px;
                        border: 1px solid #ced4da;
                     " />
               </div>

               <a
                  href="javascript:void(0);"
                  class="list-view btn btn-link p-button p-button-success exportPracticesButton"
                  style="margin-left: auto; margin-right: 20px; margin-bottom: -2px"
                  title="Export Table"
                  alt="Export Table"
                  (click)="exportDataClicked()">
                  <i
                     class="las la-file-export"
                     style="font-size: 14px"></i>
                  Export CSV
               </a>
               <i
                  style="color: #d0d0d0"
                  class="icon fas fa-hospital"></i>
            </div>
            <div *ngIf="isLoadingAllPractices; else practicesTable">
               <div class="spinner"></div>
               <!-- Spinner for loading -->
            </div>
            <ng-template #practicesTable>
               <div class="table-container practicesTable">
                  <table
                     matSort
                     (matSortChange)="sortValue.set($event)"
                     style="margin-top: 0px; width: 100%">
                     <thead>
                        <tr class="allPHeader">
                           <th *ngIf="isAdmin"></th>
                           <th></th>
                           <th
                              mat-sort-header="batchStatus"
                              style="padding-right: 0px !important">
                              Practice Status
                           </th>
                           <th
                              mat-sort-header="pricingPartner"
                              style="width: 75px; padding-left: 5px !important; padding-right: 10px !important">
                              Pricing
                              <br />
                              Captain
                           </th>
                           <th mat-sort-header="discussionComplete">
                              Deadline
                              <br />
                              for Reviews
                           </th>
                           <th mat-sort-header="scheduledFor">
                              PIMS
                              <br />
                              Writeback
                           </th>
                           <th
                              mat-sort-header="writebackSuccess"
                              style="padding-right: 0px">
                              Writeback
                              <br />
                              Success
                           </th>
                           <th mat-sort-header="currentLTMRevenue">
                              L12M Rev.
                              <br />
                              Baseline
                           </th>

                           <!-- $ Impact -->
                           <th
                              class="dollarImpact"
                              mat-sort-header="revenueImpact">
                              <br />
                              <span style="padding-left: 8px">modeled</span>
                           </th>
                           <th
                              class="dollarImpact"
                              mat-sort-header="requestedRevenueImpact">
                              requested
                           </th>
                           <th
                              class="dollarImpact"
                              mat-sort-header="finalRevenueImpact"
                              style="position: relative; overflow: visible; white-space: nowrap">
                              <div style="margin-bottom: 0px">
                                 <div style="margin-bottom: 8px; font-size: 15px; margin-left: -130px">Estimated $ Impact</div>
                                 <div style="margin-bottom: 0px">final</div>
                              </div>
                           </th>

                           <!-- % Impact
									<th class="percentImpact" mat-sort-header="revenueImpactPct"><span style="padding-left: 8px;">modeled</span></th>
									<th class="percentImpact" mat-sort-header="requestedRevenueImpactPct">
                                        requested
                                    </th>
                                    <th class="percentImpact" mat-sort-header="finalRevenueImpactPct" style="position: relative; overflow: visible; white-space: nowrap;">
                                        <div style="margin-bottom: 0px;">
                                            <div style="margin-bottom: 8px; font-size: 16px; margin-left: -86px;">% Impact</div>
                                            <div style="margin-bottom: 0px;">final</div>
                                        </div>
                                    </th>
                                    -->

                           <!-- % Price Change -->
                           <th
                              class="percentPriceChange"
                              mat-sort-header="modelAverageChangePct">
                              <span style="padding-left: 8px">modeled</span>
                           </th>
                           <th
                              class="percentPriceChange"
                              mat-sort-header="requestedAverageChangePct">
                              requested
                           </th>
                           <th
                              class="percentPriceChange"
                              mat-sort-header="finalAverageChangePct"
                              style="position: relative; overflow: visible; white-space: nowrap">
                              <div style="margin-bottom: 0px; overflow: visible">
                                 <div style="margin-bottom: 8px; font-size: 15px; margin-left: -130px">Avg Price Change %</div>
                                 <div style="margin-bottom: 0px">final</div>
                              </div>
                           </th>

                           <!-- <th mat-sort-header="finalAverageChange">Final Avg $<br>Price Change</th> -->

                           <!-- <th mat-sort-header="weightedImpactChange"><span style="padding-left: 8px;">Final Wtd Avg $<br>Price Change</span></th> -->
                           <!-- <th mat-sort-header="weightedImpactChangePct">Final Wtd Avg %<br>Price Change</th> -->

                           <th
                              class="percentWeightedPriceChange"
                              mat-sort-header="modelAverageWeightedChangePct">
                              <span style="padding-left: 8px">modeled</span>
                           </th>
                           <th
                              class="percentWeightedPriceChange"
                              mat-sort-header="requestedAverageWeightedChangePct">
                              requested
                           </th>
                           <th
                              class="percentWeightedPriceChange"
                              mat-sort-header="finalAverageWeightedChangePct"
                              style="position: relative; overflow: visible; white-space: nowrap">
                              <div style="margin-bottom: 0px; overflow: visible">
                                 <div style="margin-bottom: 8px; font-size: 15px; margin-left: -150px">Avg Wtd Price Change %</div>
                                 <div style="margin-bottom: 0px">final</div>
                              </div>
                           </th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr *ngFor="let practice of filteredPractices()">
                           <td
                              *ngIf="isAdmin"
                              style="padding-left: 11px !important; padding-right: 0px !important">
                              <!--validate<a href="javascript:void(0);" class="refreshBatchButton" (click)="resetBatch(practice.practiceSKey)" alt="Reset batch status to started" title="Reset batch status to started" style="margin-top:2px; display:block; width:25px; height:25px; margin-right: -1px; border-radius:100%; padding:0px; text-align:center; line-height:25px; font-size:10px;"><i style="color:#ffffff; font-size:10px;" class="fa fa-refresh"></i></a>-->
                              <a
                                 href="javascript:void(0);"
                                 class="refreshBatchButton"
                                 (click)="openSettings(practice)"
                                 alt="Settings"
                                 title="Settings"
                                 style="
                                    margin-top: 2px;
                                    display: block;
                                    width: 25px;
                                    height: 25px;
                                    margin-right: -1px;
                                    border-radius: 100%;
                                    padding: 0px;
                                    text-align: center;
                                    line-height: 25px;
                                    font-size: 10px;
                                 ">
                                 <i
                                    style="color: #ffffff; font-size: 10px"
                                    class="fa fa-cog"></i>
                              </a>
                           </td>
                           <td
                              class="pName"
                              style="
                                 white-space: pre-line;
                                 text-align: left;
                                 max-width: 185px;
                                 padding-right: 10px !important;
                                 padding-left: 10px !important;
                              ">
                              <a
                                 routerLink="{{ practice.practiceSKey }}"
                                 class="dashboardPracticeName"
                                 style="text-decoration: none; color: #000000; font-size: 12px">
                                 <i class="fas fa-eye"></i>
                                 &nbsp;&nbsp;{{ practice.practiceName }}
                              </a>
                              <p style="color: #000000; font-size: 12px; font-weight: 400; font-style: italic">
                                 HM: {{ practice.hmFirstName }} {{ practice.hmLastName }}
                              </p>
                              <p>
                                 <a
                                    style="color: #000000; font-size: 12px; font-weight: 400; font-style: italic"
                                    href="mailto:{{ practice.hmEmail }}">
                                    {{ practice.hmEmail }}
                                 </a>
                              </p>
                              <p style="color: #000000; font-size: 12px; font-weight: 400; font-style: italic">
                                 ({{ practice.practicePhone | slice : 0 : 3 }}) {{ practice.practicePhone | slice : 3 : 6 }}-{{
                                    practice.practicePhone | slice : 6 : 10
                                 }}
                              </p>
                           </td>

                           <td style="padding-right: 0px !important">
                              <span
                                 *ngIf="practice.batchStatus === 0"
                                 class="badge status-badge badge-bg-failed">
                                 <i
                                    class="la la-clock"
                                    style="margin-left: 4px; font-size: 16px; margin-right: 7px"></i>
                                 No Feedback Received
                              </span>
                              <span
                                 *ngIf="practice.batchStatus === 1"
                                 class="badge status-badge badge-bg-pending">
                                 <i
                                    class="fas fa-tasks"
                                    style="margin-left: 4px; font-size: 16px; margin-right: 8px"></i>
                                 Feedback Started
                              </span>
                              <span
                                 *ngIf="practice.batchStatus === 2"
                                 class="badge status-badge badge-bg-ready">
                                 <i
                                    class="fas fa-business-time"
                                    style="margin-left: 6px; font-size: 16px; margin-right: 8px"></i>
                                 Pending Review
                              </span>
                              <span
                                 *ngIf="practice.batchStatus === 3"
                                 class="badge status-badge badge-bg-complete">
                                 <i
                                    class="la la-clipboard-check"
                                    style="margin-left: 1px; font-size: 16px; margin-right: 6px"></i>
                                 Submitted
                              </span>
                           </td>

                           <td
                              style="
                                 white-space: pre-line;
                                 width: 75px;
                                 padding-left: 5px !important;
                                 padding-right: 10px !important;
                                 text-align: left;
                              ">
                              {{ practice.pricingPartner }}
                           </td>
                           <td>{{ practice.discussionComplete | date : "MM/dd/yyyy" }}</td>
                           <td>{{ practice.scheduledFor | date : "MM/dd/yyyy" }}</td>
                           <td style="padding-right: 0px">
                              <div
                                 *ngIf="hasStartedWriteback(practice) && practice.writebackSuccess >= 0"
                                 class="practiceWritebackStatus"
                                 [ngClass]="getStatusBackgroundColorClass(practice.writebackSuccess)">
                                 {{ practice.writebackSuccess | percent : "1.0-2" }}
                              </div>
                           </td>
                           <td>{{ practice.currentLTMRevenue | currency : "USD" : "symbol" : "1.0-0" }}</td>

                           <td>{{ practice.revenueImpact | currency : "USD" : "symbol" : "1.0-0" }}</td>
                           <td>{{ practice.requestedRevenueImpact | currency : "USD" : "symbol" : "1.0-0" }}</td>
                           <td>{{ practice.finalRevenueImpact | currency : "USD" : "symbol" : "1.0-0" }}</td>

                           <!--
									<td>{{ getFormattedPct(practice.revenueImpactPct) }}</td>
									<td>{{ getFormattedPct(practice.requestedRevenueImpactPct) }}</td>
									<td>{{ getFormattedPct(practice.finalRevenueImpactPct) }}</td>
                                    -->

                           <td>{{ getFormattedPct(practice.modelAverageChangePct) }}</td>
                           <td>{{ getFormattedPct(practice.requestedAverageChangePct) }}</td>
                           <td>{{ getFormattedPct(practice.finalAverageChangePct) }}</td>

                           <!-- <td>{{ practice.finalAverageChange | currency:'USD':'symbol':'1.1-1' }}</td> -->
                           <!-- <td>{{ practice.weightedImpactChange | currency:'USD':'symbol':'1.1-1' }}</td> -->

                           <td>{{ getFormattedPct(practice.modeledWeightedImpactChangePct) }}</td>
                           <td>{{ getFormattedPct(practice.requestedWeightedImpactChangePct) }}</td>
                           <td>{{ getFormattedPct(practice.weightedImpactChangePct) }}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </ng-template>
         </div>
      </div>

      <!-- CSV Download Modal -->
      <div
         *ngIf="isExportingCSV"
         class="csv-custom-modal modal-dialog-centered">
         <div
            class="csv-modal-content"
            style="width: 450px">
            <h2>Exporting CSV...</h2>
            <div class="spinner"></div>
            <p>Please wait (~20 seconds) while the CSV is generated.</p>
            <p>This dialog will close automatically when finished.</p>
            <button
               mat-button
               (click)="closePopup()"
               class="btn btn-primary"
               style="font-size: 13px; font-weight: 600; margin-top: 12px">
               Close
            </button>
         </div>
      </div>
   </section>
</span>
